import {
  SERVICE_FAILURE,
  ADD_ITEM_TO_CART,
  ADD_ITEM_TO_CART_SUCCESS,
  ADD_ITEM_TO_CART_FAILURE,
  UPDATE_CART,
  UPDATE_CART_SUCCESS,
  UPDATE_CART_FAILURE,
  REMOVE_CART,
  REMOVE_CART_SUCCESS,
  REMOVE_CART_FAILURE,
  REMOVE_CART_ITEM,
  REMOVE_CART_ITEM_SUCCESS,
  REMOVE_CART_ITEM_FAILURE,
  REQUEST_QUOTE,
  REQUEST_QUOTE_SUCCESS,
  BULK_ADD_ITEM_TO_CART,
  BULK_ADD_ITEM_TO_CART_SUCCESS,
  DOWNLOAD_CSV_SUCCESS,
  SHOW_ORDER_NOT_AVAILABLE,
  SHOW_BLOCKED_ACCOUNT_MODAL,
  RESET_CART_ERROR_MESSAGE,
  CREATE_REQUISITION,
  REQUISITION_SUBMIT_SUCCESS,
  VALIDATE_QUOTE_CODE,
  QUOTE_DETAIL_FAILURE,
  REQUEST_QUOTE_CLICK,
  SHARE_CART_SUBMIT,
  SHARE_CART_SUBMIT_SUCCESS,
  SHARE_CART_MODAL_ANALYTICS,
  SHARE_CART_CLEAR,
  SHARE_CONFIRMATION_SUBMIT,
  SHARE_CONFIRMATION_SUBMIT_SUCCESS,
  SHARE_CONFIRMATION_CLEAR,
  LOAD_ACCOUNT_DATA,
} from './ShoppingCart.constants';

export const removeCartFailure = error => ({
  type: REMOVE_CART_FAILURE,
  error,
});

export const removeCart = (isWholeCart = false) => ({
  type: REMOVE_CART,
  isWholeCart,
});

export const removeCartSuccess = data => ({
  type: REMOVE_CART_SUCCESS,
  data,
});

export const addItemToCart = (
  code,
  quantity,
  isFromHeaderQuickOrder = false,
  isProductRecommendation = false
) => ({
  type: ADD_ITEM_TO_CART,
  code,
  quantity,
  isFromHeaderQuickOrder,
  isProductRecommendation,
});

export const addItemToCartDataSuccess = data => ({
  type: ADD_ITEM_TO_CART_SUCCESS,
  data,
});

export const addItemToCartFailure = data => ({
  type: ADD_ITEM_TO_CART_FAILURE,
  data,
});

export const updateCart = data => ({
  type: UPDATE_CART,
  data,
});

export const updateCartSuccess = data => ({
  type: UPDATE_CART_SUCCESS,
  data,
});

export const updateCartFailure = data => ({
  type: UPDATE_CART_FAILURE,
  data,
});

export const removeCartItem = data => ({
  type: REMOVE_CART_ITEM,
  data,
});

export const removeCartItemSuccess = data => ({
  type: REMOVE_CART_ITEM_SUCCESS,
  data,
});

export const removeCartItemFailure = data => ({
  type: REMOVE_CART_ITEM_FAILURE,
  data,
});

export const serviceFailure = data => ({
  type: SERVICE_FAILURE,
  data,
});

export const requestQuote = body => ({
  type: REQUEST_QUOTE,
  body,
});

export const requestQuoteSuccess = data => ({
  type: REQUEST_QUOTE_SUCCESS,
  data,
});

export const bulkAddItemToCart = formData => ({
  type: BULK_ADD_ITEM_TO_CART,
  formData,
});

export const bulkAddItemToCartSuccess = data => ({
  type: BULK_ADD_ITEM_TO_CART_SUCCESS,
  data,
});

export const downloadCSVSuccess = () => ({
  type: DOWNLOAD_CSV_SUCCESS,
});

export const showOrderNotAvailable = () => ({
  type: SHOW_ORDER_NOT_AVAILABLE,
});

export const showBlockedAccountModal = () => ({
  type: SHOW_BLOCKED_ACCOUNT_MODAL,
});

export const resetCartErrorMessage = () => ({
  type: RESET_CART_ERROR_MESSAGE,
});

export const createRequisition = () => ({
  type: CREATE_REQUISITION,
});

export const requisitionSubmitSuccess = data => ({
  type: REQUISITION_SUBMIT_SUCCESS,
  data,
});

export const validateQuoteCode = data => ({
  type: VALIDATE_QUOTE_CODE,
  data,
});

export const quoteDetailsFailure = data => ({
  type: QUOTE_DETAIL_FAILURE,
  data,
});

export const requestQuoteClick = () => ({
  type: REQUEST_QUOTE_CLICK,
});

export const shareCartSubmit = data => ({
  type: SHARE_CART_SUBMIT,
  data,
});

export const shareCartSubmitSuccess = data => ({
  type: SHARE_CART_SUBMIT_SUCCESS,
  data,
});

export const shareCartAnalytics = () => ({
  type: SHARE_CART_MODAL_ANALYTICS,
});

export const shareCartClear = data => ({
  type: SHARE_CART_CLEAR,
  data,
});

export const shareConfirmationSubmit = data => ({
  type: SHARE_CONFIRMATION_SUBMIT,
  data,
});

export const shareConfirmationSubmitSuccess = data => ({
  type: SHARE_CONFIRMATION_SUBMIT_SUCCESS,
  data,
});

export const shareConfirmationClear = data => ({
  type: SHARE_CONFIRMATION_CLEAR,
  data,
});

export const loadAccountData = () => ({
  type: LOAD_ACCOUNT_DATA,
});
export default [loadAccountData];
